import { Currency, PayableRow } from "@wingspanhq/wingspan-api-sdk";

/**
 * The payables an off-cycle run in `currency` would pay, out of the
 * approved-and-unpaid rows the server returned.
 *
 * `ContractorVendorPayrollRunCreate` takes one `currency` and pays only that,
 * but `searchPayableRows` has no currency filter — so the narrowing happens
 * here.
 *
 * It deliberately does **not** also exclude payables another run is holding.
 * `PayableRow.payrollRunId` is unreliable in both directions (WIN-16127 §2): it
 * lags a claim by ~70s, and it keeps naming a run for minutes after that run is
 * deleted and its payables released. Excluding on it was measured against
 * integration to empty this screen — "No payables available for off-cycle
 * payroll", Run payroll disabled — for minutes after discarding a draft, while
 * four approved payables were in fact available. Blocking payroll on a stale
 * field is worse than a preview that can briefly overstate, and the server's
 * `ApprovedPayables` scope decides what actually gets paid either way. Add the
 * exclusion back once the field is trustworthy.
 */
export const selectorOffCyclePayrollPayables = (params: {
  payables: PayableRow[];
  currency: Currency;
}): PayableRow[] =>
  params.payables.filter(payable => payable.currency === params.currency);
